import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import withEnabledLocations from 'containers/withEnabledLocations';
import { isLocationPls } from 'utils/locations';
import { isMobileApp } from 'utils/mode';
import Selected from 'resources/Button-Check-selected.png';
import Unchecked from 'resources/unchecked-circle.png';
import { FORM_NAME } from '../formConstants';
import './LocationPreferenceFormPage.css';

class LocationPreferenceFormPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDownloadCvAppNote: false
    };
  }

  onExtraStep = () => {
    this.setState({ showDownloadCvAppNote: true });
  };

  handleContinueClick = () => {
    if (isMobileApp() && isLocationPls(this.props.preferredLocation)) {
      this.onExtraStep();
    } else {
      this.props.onSubmit();
    }
  };

  handleSelect = casinoName => {
    this.props.change('preferredLocation', casinoName);
  };

  renderCasinoLocationOptions = () => {
    const { preferredLocation, enabledLocations } = this.props;
    return enabledLocations.map(location => {
      const isSelected = location.id === preferredLocation;
      return (
        <button
          className="casino-location"
          key={location.id}
          onClick={() => this.handleSelect(location.id)}
          type="button"
        >
          <div
            className={`casino-select-btn ${
              isSelected ? 'selected' : 'not-selected'
            }`}
          >
            <img
              className="casino-checkbox"
              src={isSelected ? Selected : Unchecked}
              alt={`${location.id} Location`}
            />
          </div>
          <img src={location.image} alt={location.name} />
          <div className="details-container">
            <div className="casino-name">{location.name}</div>
            <span className="casino-addr">{location.address}</span>
          </div>
        </button>
      );
    });
  };

  render() {
    if (this.state.showDownloadCvAppNote) {
      return (
        <div className="casino-location-preference-form download-cv-app-notice">
          <div className="account-warning-text">
            {`Accounts created in this app will not work at the `}
            {`${this.props.preferredLocation} property.`}
          </div>
          <div className="get-app-text">
            {`Please use our latest app experience, Casinoverse, to create an
            account for our ${this.props.preferredLocation} property.`}
          </div>
          <a
            className="button-color-blue btn-block get-the-app-btn"
            href="https://windcreekcasino.com/casinoverse"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get The App
          </a>
        </div>
      );
    }
    return (
      <div className="casino-location-preference-form">
        <div className="form-title-container">
          <div className="title">Your Casino</div>
          <div className="sub-title">
            For the most relevant activities, events & rewards, select the
            casino you visit most often
          </div>
        </div>
        <div className="casino-locations-container">
          {this.renderCasinoLocationOptions()}
        </div>
        <button
          className="btn button-color-green"
          onClick={this.handleContinueClick}
          type="button"
          disabled={!this.props.preferredLocation}
        >
          Continue
        </button>
      </div>
    );
  }
}

LocationPreferenceFormPage.propTypes = {};

const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = createStructuredSelector({
  preferredLocation: state => formSelector(state, 'preferredLocation')
});

const withConnect = connect(mapStateToProps);
const withReduxForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
});

const WrappedComponent = withEnabledLocations(
  withConnect(withReduxForm(LocationPreferenceFormPage))
);

WrappedComponent.FormFields = ['preferredLocation'];

LocationPreferenceFormPage.propTypes = {
  preferredLocation: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired
};

export default WrappedComponent;
